"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONScRGBColorConverter = exports.JSONColorHSLConverter = exports.JSONDrawingColorModelInfoConverter = exports.JSONDrawingColorConverter = void 0;
var color_hsl_1 = require("../../color/color-hsl");
var sc_rgbcolor_1 = require("../../color/sc-rgbcolor");
var drawing_color_1 = require("../../drawing/drawing-color");
var drawing_color_model_info_1 = require("../../drawing/drawing-color-model-info");
var json_general_enums_1 = require("../enums/json-general-enums");
var JSONDrawingColorConverter = (function () {
    function JSONDrawingColorConverter() {
    }
    JSONDrawingColorConverter.convertFromJSON = function (obj) {
        var info = JSONDrawingColorModelInfoConverter.convertFromJSON(obj[json_general_enums_1.JSONSDrawingColorProperty.Color]);
        return new drawing_color_1.DrawingColor(info);
    };
    return JSONDrawingColorConverter;
}());
exports.JSONDrawingColorConverter = JSONDrawingColorConverter;
var JSONDrawingColorModelInfoConverter = (function () {
    function JSONDrawingColorModelInfoConverter() {
    }
    JSONDrawingColorModelInfoConverter.convertFromJSON = function (obj) {
        var result = new drawing_color_model_info_1.DrawingColorModelInfo();
        result._rgb = obj[json_general_enums_1.JSONSDrawingColorModelInfoProperty.Rgb];
        result._systemColor = obj[json_general_enums_1.JSONSDrawingColorModelInfoProperty.System];
        result._schemeColor = obj[json_general_enums_1.JSONSDrawingColorModelInfoProperty.Scheme];
        result._preset = obj[json_general_enums_1.JSONSDrawingColorModelInfoProperty.Preset];
        result._hsl = JSONColorHSLConverter.convertFromJSON(obj[json_general_enums_1.JSONSDrawingColorModelInfoProperty.Hsl]);
        result._scRgb = JSONScRGBColorConverter.convertFromJSON(obj[json_general_enums_1.JSONSDrawingColorModelInfoProperty.ScRgb]);
        result._colorType = obj[json_general_enums_1.JSONSDrawingColorModelInfoProperty.ColorType];
        return result;
    };
    return JSONDrawingColorModelInfoConverter;
}());
exports.JSONDrawingColorModelInfoConverter = JSONDrawingColorModelInfoConverter;
var JSONColorHSLConverter = (function () {
    function JSONColorHSLConverter() {
    }
    JSONColorHSLConverter.convertFromJSON = function (obj) {
        var hue = obj[json_general_enums_1.JSONSColorHSLProperty.Hue];
        var saturation = obj[json_general_enums_1.JSONSColorHSLProperty.Saturation];
        var luminance = obj[json_general_enums_1.JSONSColorHSLProperty.Luminance];
        return new color_hsl_1.ColorHSL(hue, saturation, luminance);
    };
    return JSONColorHSLConverter;
}());
exports.JSONColorHSLConverter = JSONColorHSLConverter;
var JSONScRGBColorConverter = (function () {
    function JSONScRGBColorConverter() {
    }
    JSONScRGBColorConverter.convertFromJSON = function (obj) {
        var scR = obj[json_general_enums_1.JSONSScRGBColorProperty.ScR];
        var scG = obj[json_general_enums_1.JSONSScRGBColorProperty.ScG];
        var scB = obj[json_general_enums_1.JSONSScRGBColorProperty.ScB];
        return new sc_rgbcolor_1.ScRGBColor(scR, scG, scB);
    };
    return JSONScRGBColorConverter;
}());
exports.JSONScRGBColorConverter = JSONScRGBColorConverter;
